import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "./baseQuery";
import { API_SERVER } from "../utils/urlBack_End";

export const clientesApi = createApi({
  reducerPath: "clientesApi",
  baseQuery: baseQuery(`${API_SERVER}/clientes`),
  tagTypes: [
    "Clientes",
    "clientesPorGrupo",
    "clientesSinGrupo",
    "clavesCliente",
    "PortafoliosCliente",
    "ArchivosPortafolioCliente",
    "ClienteEmailCC",
    "ClientesMorosos",
    "PortalStatus",
    "Socios",
    "Contratos",
    "Poderes",
    "tablaClientes",
  ],
  endpoints: (builder) => ({
    buscarClientes: builder.query({
      query: (params) => ({
        url: "/buscar",
        params,
      }),
      providesTags: [{ type: "Clientes", id: "SEARCH" }],
      transformResponse: (response) => response.data,
    }),
    buscarClientesEmpleado: builder.query({
      query: ({ idEmpleado, sucursal, ...params }) => ({
        url: `/empleado/${idEmpleado}/${sucursal}/buscar`,
        params,
      }),
      providesTags: [{ type: "Clientes", id: "SEARCH" }],
      transformResponse: (response) => response.data,
    }),
    /** @deprecated Usar buscarClientes */
    getClientes: builder.query({
      query: ({ estado = "activo" } = {}) => ({
        url: "/",
        method: "GET",
        params: { estado },
      }),
      providesTags: ["Clientes"],
    }),
    getCliente: builder.query({
      query: ({ rut }) => ({
        url: `/${rut}`,
        method: "GET",
      }),
    }),
    getPoderCliente: builder.query({
      query: ({ rut, sucursal }) => ({
        url: `/poder/${rut}`,
        method: "GET",
        params: { sucursal },
      }),
      providesTags: (result, error, { rut }) => [{ type: "Poderes", id: rut }],
    }),
    generarUrlPrefirmadaPoder: builder.query({
      query: ({ id, sucursal }) => ({
        url: `/poder/${id}/url-prefirmada`,
        method: "GET",
        params: { sucursal },
      }),
    }),
    addPoderCliente: builder.mutation({
      query: (body) => ({
        url: `/poder`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Poderes"],
    }),

    deletePoderCliente: builder.mutation({
      query: ({ id, sucursal }) => ({
        url: `/poder/${id}`,
        method: "DELETE",
        params: { sucursal },
      }),
      invalidatesTags: ["Poderes"],
    }),
    getTablaCliente: builder.query({
      query: () => `/tablaCliente`,
      providesTags: ["tablaClientes"],
    }),
    getNuevosClientesIngresadosPorMes: builder.query({
      query: ({ fecha, tipo }) => ({
        url: `/nuevosClientesIngresadosPorMes/${tipo}`,
        method: "GET",
        params: { fecha },
      }),
    }),
    cantidadClientesActivosConFiltros: builder.query({
      query: ({ rut, sucursales, fechaInicio, fechaFin }) => {
        const params = { rut };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }

        return {
          url: `/cantidadClientesActivosConFiltros`,
          method: "GET",
          params,
        };
      },
    }),

    getNuevosClientesIngresadosPorRango: builder.query({
      query: ({ rut, fechaInicio, fechaFin, sucursales, tipo }) => {
        const params = { rut };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }

        return {
          url: `/nuevosClientesIngresadosPorRango/${tipo}`,
          method: "GET",
          params,
        };
      },
    }),

    obtenerDetalleDivisionClientes: builder.query({
      query: ({ tipo, rut, sucursales, fechaInicio, fechaFin }) => {
        const params = { rut };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }

        return {
          url: `/detalleDivisionClientes/${tipo}`,
          method: "GET",
          params,
        };
      },
    }),
    obtenerDistribucionDeClientes: builder.query({
      query: ({ rut, sucursales, fechaInicio, fechaFin }) => {
        const params = { rut };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }
        return { url: `/distribucionDeClientes`, method: "GET", params };
      },
    }),
    obtenerClientesPorDivision: builder.query({
      query: ({ rut, sucursales, fechaInicio, fechaFin }) => {
        const params = { rut };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }
        return { url: `/obtenerClientesPorDivision`, method: "GET", params };
      },
    }),
    ultimosClientesGestor: builder.query({
      query: ({ rut, sucursales }) => {
        const params = { rut };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }
        return { url: `/ultimosClientesGestor`, method: "GET", params };
      },
    }),
    obtenerClientesPorGrupo: builder.query({
      query: () => `/clientesPorGrupo`,
      providesTags: ["clientesPorGrupo"],
    }),
    obtenerClientesSinGrupo: builder.query({
      query: () => `/clientesSinGrupo`,
      providesTags: ["clientesSinGrupo"],
    }),
    /** @deprecated Usar buscarClientesEmpleado */
    getClientesEmpleado: builder.query({
      query: ({ rut, sucursal }) => `/empleado/${rut}/${sucursal}`,
      providesTags: ["Clientes"],
    }),
    addCliente: builder.mutation({
      query: (body) => ({
        url: `/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Clientes"],
    }),
    editarCliente: builder.mutation({
      query: ({ rut, datos }) => ({
        url: `/${rut}`,
        method: "PUT",
        body: { datos },
      }),
      invalidatesTags: ["Clientes"],
    }),
    addAsociarGrupos: builder.mutation({
      query: (body) => ({
        url: `/asociarGrupos`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["clientesSinGrupo"],
    }),
    actualizarOrganigramaGrupo: builder.mutation({
      query: (formData) => ({
        url: `/clientesPorGrupo/actualizarOrganigramaGrupo`,
        method: "PATCH",
        body: formData,
      }),
      invalidatesTags: ["clientesPorGrupo"],
    }),
    asociarOrganigramaGrupo: builder.mutation({
      query: (formData) => ({
        url: `/clientesPorGrupo/asociarOrganigramaGrupo`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["clientesPorGrupo"],
    }),
    generarUrlPrefirmadaOrganigrama: builder.query({
      query: ({ nombreElemento, sucursal }) =>
        `/clientesPorGrupo/organigrama/${encodeURIComponent(nombreElemento)}/url-prefirmada?sucursal=${sucursal}`,
    }),
    obtenerClavesCliente: builder.query({
      query: ({ rut }) => `/clavesPortales/${rut}`,
      providesTags: ["clavesCliente"],
    }),
    exportarClavesClienteLista: builder.mutation({
      query: (lista_ruts) => ({
        url: "/clavePortales/exportar",
        method: "POST",
        body: lista_ruts,
      }),
    }),
    editarClaveCliente: builder.mutation({
      query: ({ refCliente, ...body }) => ({
        url: `/clavesPortales/${refCliente}`,
        method: "PUT",
        body: body,
      }),
      invalidatesTags: ["clavesCliente"],
    }),
    agregarClaveSitax: builder.mutation({
      query: (body) => ({
        url: `/clavesPortales/sitax/crear`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["clavesCliente"],
    }),
    agregarClavePortales: builder.mutation({
      query: (body) => ({
        url: `/clavesPortales`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["clavesCliente"],
    }),
    eliminarClaveCliente: builder.mutation({
      query: ({ id, refSucursal }) => ({
        url: `/clavesPortales/${id}`,
        method: "DELETE",
        body: { refSucursal },
      }),
      invalidatesTags: ["clavesCliente"],
    }),
    cambiarVisibilidadClave: builder.mutation({
      query: ({ id, visibleCliente, refSucursal }) => ({
        url: `/clavesPortales/${id}/visibilidad`,
        method: "PATCH",
        body: { visibleCliente, refSucursal },
      }),
      invalidatesTags: ["clavesCliente"],
    }),
    desencriptarClave: builder.mutation({
      query: (body) => ({
        url: `/clavesPortales/desencriptar`,
        method: "POST",
        body: body,
      }),
    }),
    obtenerHistorialClave: builder.query({
      query: ({ refCliente, institucion, usuario, refSucursal }) => ({
        url: `/clavesPortales/historial`,
        method: "GET",
        params: { refCliente, institucion, usuario, refSucursal },
      }),
      providesTags: (result, error, { refCliente, institucion, usuario }) => [
        {
          type: "clavesCliente",
          id: `${refCliente}-${institucion}-${usuario}`,
        },
      ],
    }),
    obtenerPortafoliosCliente: builder.query({
      query: ({ rut }) => `/portafolio/${rut}`,
      providesTags: (result, error, { rut }) => [
        { type: "PortafoliosCliente", id: rut },
        "PortafoliosCliente",
      ],
    }),

    agregarPortafolioCliente: builder.mutation({
      query: (body) => ({
        url: `/portafolio`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: (result, error, { refCliente }) => [
        { type: "PortafoliosCliente", id: refCliente },
        "PortafoliosCliente",
      ],
    }),

    actualizarPortafolioCliente: builder.mutation({
      query: (body) => ({
        url: `/portafolio`,
        method: "PUT",
        body: body,
      }),
      invalidatesTags: (result, error, { refCliente }) => [
        { type: "PortafoliosCliente", id: refCliente },
        "PortafoliosCliente",
      ],
    }),

    agregarArchivoPortafolio: builder.mutation({
      query: (body) => ({
        url: `/portafolio/archivos`,
        method: "POST",
        body: body,
      }),
      // Necesitamos invalidar los portafolios para que se actualicen los archivos
      invalidatesTags: (result, error, body) => {
        // Aquí necesitarías el rut del cliente. Si no lo tienes en el body,
        // podrías invalidar todos los portafolios
        return ["PortafoliosCliente"];
      },
    }),

    eliminarArchivoPortafolio: builder.mutation({
      query: ({ id, refPortafolioCliente, refSucursal }) => ({
        url: `/portafolio/archivos/${id}/${refPortafolioCliente}`,
        method: "DELETE",
        body: { refSucursal },
      }),
      invalidatesTags: ["PortafoliosCliente"],
    }),

    eliminarPortafolioCliente: builder.mutation({
      query: ({ id, refSucursal }) => ({
        url: `/portafolio/${id}`,
        method: "DELETE",
        body: { refSucursal },
      }),
      invalidatesTags: (result, error, { rut }) => [
        { type: "PortafoliosCliente", id: rut },
        "PortafoliosCliente",
      ],
    }),

    getEmailsCC: builder.query({
      query: (rutCliente) => `/emailscc/${rutCliente}`,
      providesTags: ["ClienteEmailCC"],
    }),
    addEmailCC: builder.mutation({
      query: (data) => ({
        url: "/emailscc",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ClienteEmailCC"],
    }),
    updateEmailCC: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/emailscc/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["ClienteEmailCC"],
    }),
    deleteEmailCC: builder.mutation({
      query: (id) => ({
        url: `/emailscc/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ClienteEmailCC"],
    }),
    toggleActivoEmailCC: builder.mutation({
      query: ({ id, activo }) => ({
        url: `/emailscc/${id}/toggle`,
        method: "PATCH",
        body: { activo },
      }),
      invalidatesTags: ["ClienteEmailCC"],
    }),
    validarRutCliente: builder.mutation({
      query: ({ rutAntiguo, rutNuevo }) => ({
        url: `/validarRut/${rutAntiguo}`,
        method: "PATCH",
        body: { rutNuevo },
      }),
      invalidatesTags: ["Clientes"],
    }),
    obtenerPortalStatus: builder.query({
      query: ({ rut }) => `/${rut}/portalStatus`,
      providesTags: (result, error, { rut }) => [
        { type: "PortalStatus", id: rut },
      ],
    }),
    invitarPortalCliente: builder.mutation({
      query: ({ rut, refSucursal }) => ({
        url: `/${rut}/portal/invitar`,
        method: "POST",
        body: { refSucursal },
      }),
      invalidatesTags: (result, error, { rut }) => [
        { type: "PortalStatus", id: rut },
      ],
    }),
    toggleAccesoPortal: builder.mutation({
      query: ({ rut, refSucursal }) => ({
        url: `/${rut}/portal/toggleAcceso`,
        method: "PATCH",
        body: { refSucursal },
      }),
      invalidatesTags: (result, error, { rut }) => [
        { type: "PortalStatus", id: rut },
      ],
    }),
    resetPasswordPortalDesdeEmpleado: builder.mutation({
      query: ({ rut, refSucursal }) => ({
        url: `/${rut}/portal/resetPassword`,
        method: "POST",
        body: { refSucursal },
      }),
    }),
    invitarPortalClienteLote: builder.mutation({
      query: ({ ruts, refSucursal }) => ({
        url: `/portal/invitar/lote`,
        method: "POST",
        body: { ruts, refSucursal },
      }),
      invalidatesTags: ["Clientes"],
    }),
    getSocios: builder.query({
      query: ({ rutCliente }) => `/socios/${rutCliente}`,
      providesTags: (result, error, { rutCliente }) => [
        { type: "Socios", id: rutCliente },
      ],
    }),
    getEmpresasComoSocio: builder.query({
      query: ({ rutSocio }) => `/socios/pertenece/${rutSocio}`,
      providesTags: (result, error, { rutSocio }) => [
        { type: "Socios", id: `pertenece-${rutSocio}` },
      ],
    }),
    addSocio: builder.mutation({
      query: (body) => ({
        url: `/socios`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { refCliente }) => [
        { type: "Socios", id: refCliente },
      ],
    }),
    eliminarSocio: builder.mutation({
      query: ({ refCliente, rutSocio }) => ({
        url: `/socios/${refCliente}/${rutSocio}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { refCliente }) => [
        { type: "Socios", id: refCliente },
      ],
    }),
    obtenerClientesMorosos: builder.query({
      query: ({ sucursales }) => {
        const params = {};

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        return {
          url: "/morosos",
          method: "GET",
          params,
        };
      },
      providesTags: ["ClientesMorosos"],
    }),
    getContratoCliente: builder.query({
      query: (rutCliente) => `/contrato/${rutCliente}`,
      providesTags: ["Contratos"],
    }),

    addContratoCliente: builder.mutation({
      query: (body) => ({
        url: `/contrato`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Contratos"],
    }),

    deleteContratoCliente: builder.mutation({
      query: (id) => ({
        url: `/contrato/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Contratos"],
    }),
  }),
});

export const {
  useBuscarClientesQuery,
  useGetClientesEmpleadoQuery,
  useGetTablaClienteQuery,
  useLazyGetTablaClienteQuery,
  useGetNuevosClientesIngresadosPorRangoQuery,
  useCantidadClientesActivosConFiltrosQuery,
  useObtenerClientesPorDivisionQuery,
  useObtenerDetalleDivisionClientesQuery,
  useGetNuevosClientesIngresadosPorMesQuery,
  useObtenerClientesPorGrupoQuery,
  useUltimosClientesGestorQuery,
  useObtenerDistribucionDeClientesQuery,
  useObtenerClientesSinGrupoQuery,
  useObtenerClavesClienteQuery,
  useLazyGetNuevosClientesIngresadosPorRangoQuery,
  useLazyObtenerClavesClienteQuery,
  useExportarClavesClienteListaMutation,
  useEliminarClaveClienteMutation,
  useCambiarVisibilidadClaveMutation,
  useAgregarClavePortalesMutation,
  useDesencriptarClaveMutation,
  useObtenerHistorialClaveQuery,
  useLazyObtenerHistorialClaveQuery,
  useEditarClaveClienteMutation,
  useAgregarClaveSitaxMutation,
  useLazyObtenerClientesSinGrupoQuery,
  useLazyObtenerClientesPorGrupoQuery,
  useLazyGetNuevosClientesIngresadosPorMesQuery,
  useLazyObtenerDetalleDivisionClientesQuery,
  useLazyObtenerDistribucionDeClientesQuery,
  useLazyObtenerClientesPorDivisionQuery,
  useLazyUltimosClientesGestorQuery,
  useLazyCantidadClientesActivosConFiltrosQuery,
  useGetClientesQuery,
  useGetClienteQuery,
  useLazyGetClienteQuery,
  useLazyGetClientesEmpleadoQuery,
  useLazyGetClientesQuery,
  useAddClienteMutation,
  useEditarClienteMutation,
  useAsociarOrganigramaGrupoMutation,
  useActualizarOrganigramaGrupoMutation,
  useLazyGenerarUrlPrefirmadaOrganigramaQuery,
  useAddAsociarGruposMutation,
  useActualizarPortafolioClienteMutation,
  useAgregarArchivoPortafolioMutation,
  useAgregarPortafolioClienteMutation,
  useEliminarArchivoPortafolioMutation,
  useEliminarPortafolioClienteMutation,
  useLazyObtenerPortafoliosClienteQuery,
  useObtenerPortafoliosClienteQuery,
  useGetEmailsCCQuery,
  useAddEmailCCMutation,
  useDeleteEmailCCMutation,
  useLazyGetEmailsCCQuery,
  useUpdateEmailCCMutation,
  useToggleActivoEmailCCMutation,
  useValidarRutClienteMutation,
  useObtenerClientesMorososQuery,
  useLazyObtenerClientesMorososQuery,
  useGetPoderClienteQuery,
  useLazyGetPoderClienteQuery,
  useLazyGenerarUrlPrefirmadaPoderQuery,
  useAddPoderClienteMutation,
  useDeletePoderClienteMutation,
  useObtenerPortalStatusQuery,
  useLazyObtenerPortalStatusQuery,
  useInvitarPortalClienteMutation,
  useToggleAccesoPortalMutation,
  useResetPasswordPortalDesdeEmpleadoMutation,
  useInvitarPortalClienteLoteMutation,
  useGetSociosQuery,
  useGetEmpresasComoSocioQuery,
  useAddSocioMutation,
  useEliminarSocioMutation,
  useGetContratoClienteQuery,
  useLazyGetContratoClienteQuery,
  useAddContratoClienteMutation,
  useDeleteContratoClienteMutation,
} = clientesApi;
